module.exports = __webpack_public_path__ + "img/ico-vr.cc0c856c.svg";